<template>
    <modal v-model="openModal" size="lg" :title="trans('general.page.planners.events')">
        <FormErrorAlerts :errors="errors"></FormErrorAlerts>

        <div class="row g-2">
            <div class="col-md-6">
                <div class="form-floating">
                    <input type="text" required v-model="model.title" class="form-control"
                           name="title"
                           id="title">
                    <label for="description"> {{
                            trans('general.page.planners.plan_form.title')
                        }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-floating">
                    <datepicker required :language="language()" class="form-control" v-model="date" format="dd-MM-yyyy">
                    </datepicker>
                    <label>{{ trans('general.page.planners.plan_form.date') }}</label>
                </div>
            </div>
            <div class="col-12 text-end ">
                <div
                    class=" d-inline-block p-1 px-3 border-radius-20 bg-light-purple justify-content-sm-between mb-1">
                    <label class="form-check-label me-2 hov-pointer" for="allDay">
                        {{ trans('general.page.planners.plan_form.all_day') }}
                    </label>
                    <input class="form-check-input" type="checkbox" v-model="allDay"
                           :value="true"
                           id="allDay">
                </div>
            </div>
            <div v-if="!allDay" class="col-md-6 mb-3">
                <div class="form-floating">
                    <vue-timepicker class="form-control w-100" id="start" :minute-interval="15"
                                    v-model="from"
                                    name="from" drop-direction="auto" :drop-offset-height="200"
                                    auto-scroll
                                    hide-clear-button></vue-timepicker>
                    <label
                        for="start">{{ trans('general.page.planners.plan_form.start') }}</label>
                </div>
            </div>
            <div v-if="!allDay" class="col-md-6 mb-3">
                <div class="form-floating">
                    <vue-timepicker class="form-control w-100" id="end" :minute-interval="15"
                                    v-model="to" name="to"
                                    required="true"
                                    :hour-range="fromH" :minute-range="fromM"
                                    drop-direction="auto" :drop-offset-height="200" auto-scroll
                                    hide-clear-button></vue-timepicker>
                    <label for="end">{{ trans('general.page.planners.plan_form.end') }}</label>
                </div>
            </div>
            <div class="col-md-12 my-2">
                <div class="form-floating">
                    <treeselect :value-consists-of="SELECT_PRIORITY" class="form-control tree"
                                :default-expand-level="1"
                                :multiple="true"
                                :clearable="true"
                                :limit="10"
                                :limitText="(count) => trans('general.page.planners.plan_form.and_more', {count})"
                                :noChildrenText="trans('general.page.planners.plan_form.no_results')"
                                :noOptionsText="trans('general.page.planners.plan_form.no_results')"
                                :noResultsText="trans('general.page.planners.plan_form.no_results')"
                                :placeholder="trans('general.page.planners.plan_form.members')"
                                :options="users"
                                v-model="memberIds"
                    />
                    <label>{{ trans('general.page.planners.plan_form.members') }}</label>
                </div>
            </div>
            <div class="col-12 mb-3">
                <div class="form-floating">
                                    <textarea v-model="model.description" class="form-control" name="description"
                                              id="description">
                                    </textarea>
                    <label for="description">
                        {{ trans('general.page.planners.plan_form.description') }}
                    </label>
                </div>
            </div>

            <!--                            <div class="h5 mt-4 text-dark">
                                            {{ trans('general.page.planners.plan_form.repeat_section') }}
                                        </div>
                                        <div class="col-md-6 mb-2">
                                            <div class="form-floating">
                                                <select v-model="model.recurring" class="form-select" id="floatingSelectGrid"
                                                        aria-label="Floating label select example">
                                                    <option value="">{{ trans('general.module.repeat_type.no_repeat') }}</option>
                                                    <option value="daily">{{ trans('general.module.repeat_type.daily') }}</option>
                                                    <option value="weekly">{{ trans('general.module.repeat_type.weekly') }}</option>
                                                    <option value="monthly">{{ trans('general.module.repeat_type.monthly') }}
                                                    </option>
                                                </select>
                                                <label>{{ trans('general.page.planners.plan_form.repeat') }}</label>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-2">
                                            <div class="form-floating"
                                                 v-if="model.recurring !== null && model.recurring !== ''">
                                                <datepicker class="form-control" v-model="model.recurring_till"
                                                            format="yyyy-MM-dd" id="recurringTill"></datepicker>
                                                <label for="recurringTill">{{
                                                        trans('general.page.planners.plan_form.repeat_duration')
                                                    }}</label>
                                            </div>
                                        </div>-->
        </div>
        <plan-form-footer :model="model" v-on:submit="submit" v-on="$listeners"/>
    </modal>
</template>

<script>
import Modal from "../../../theme/organisms/Modal";
import EventFormHead from "../atoms/EventFormHead";
import FormErrorAlerts from "../../../theme/molecules/FormErrorAlerts"
import datepicker from 'vuejs-datepicker';
import PlanForm from "./PlanForm";
import PlanFormFooter, {SUBMIT_PLAN_WAITER} from "./PlanFormFooter";
import moment from "moment";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker";
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    name: "EventForm",
    extends: PlanForm,
    components: {
        Modal,
        EventFormHead,
        FormErrorAlerts,
        datepicker,
        PlanFormFooter,
        VueTimepicker,
        Treeselect
    },

    data() {
        return {
            SELECT_PRIORITY: 'LEAF_PRIORITY',
            allDay: true,
            date: null,
            from: moment().format('HH:mm'),
            to: '',
            users: [],
            memberIds: []
        }
    },
    computed: {
        fromH() {
            let h = this.from ? parseInt(this.from.split(':')[0]) : 0
            return [[h, 23]]
        },

        fromM() {
            let hf = this.from ? parseInt(this.from.split(':')[0]) : null
            let h = this.to ? parseInt(this.to.split(':')[0]) : null;
            let m = this.from && hf === h ? parseInt(this.from.split(':')[1]) + 1 : 0

            return [[m, 59]]
        }

    },
    methods: {
        open(model) {
            this.clear();
            this.model = {...this.model, ...(model || {})} || this.model;
            this.date = moment(model.start).format('YYYY-MM-DD');

            this.memberIds = this.model.members ? this.model.members.map(v => v.id) : [];

            if (model.end ) {
                this.from = moment(model.start, 'YYYY-MM-DD HH:mm').format('HH:mm')
                this.to = moment(model.end, 'YYYY-MM-DD HH:mm').format('HH:mm');
                this.allDay = this.to === '00:00' && model.id;
            }

            this.openModal = true;
            this.loadMembers()
        },
        submit(event) {
            event.preventDefault();
            const url = !this.model.id ? `/plans/new` : `/plans/${this.model.id}`;
            this.model.type = this.eventType;
            let data = {...this.model};
            data.end = null;
            data.members = this.memberIds;

            const date = moment(this.date).format('YYYY-MM-DD')
            const start = moment(date + ' ' + this.from, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
            let end = null;

            if(! this.allDay) {
                end = moment(date + ' ' + this.to, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
            }

            data = {...data, start, end}

            data.recurring_till = data.recurring_till ? moment(data.recurring_till).format('YYYY-MM-DD') : null;

            axios.post(url, data)
                .then(response => {
                    this.$wait.end(SUBMIT_PLAN_WAITER);
                    this.$emit('event-saved', response.data.data)
                })
                .catch(error => {
                    this.$wait.end(SUBMIT_PLAN_WAITER);
                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0)
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                })
        },
        loadMembers() {
            axios.get('/plans/filter-members').then((result) => {
                const options = {};
                const userIds = [];
                for (const element of result.data) {
                    if (!options[element.node_id]) {
                        options[element.node_id] = {id: element.node_id, label: element.node, children: []}
                    }

                    if (!userIds.includes(element.id)) {
                        options[element.node_id].children.push(this.mapMember({id: element.id, label: element.name}));
                        userIds.push(element.id)
                    }
                }

                let nodes = Object.values(options)
                nodes = nodes.filter(v => v.children.length > 0)

                this.users = [{id: 0, label: trans('general.page.planners.plan_form.all'), children: nodes}]
            })
        },
        mapMember(user) {
            const member = this.model.members ? this.model.members.filter((member) => member.id === user.id) : null;

            if (member && member.length) {
                user.label = member[0] && member[0].pivot.approved_at
                    ? user.label + ' | ✅'
                    : (member[0] && member[0].pivot.rejected_at ? user.label + ' | ❌' : user.label)
                user.isDisabled = true;
            }

            return user;
        },
        clear() {
            this.errors = [];
            this.model = {...this.initialModel};
            this.from = moment().format('HH:mm');
            this.to = '';
            this.allDay = true;
        },
        close() {
            this.openModal = false;
        }
    },
    mounted() {
        // this.loadMembers()
    }
}
</script>

<style >
.vue-treeselect__multi-value-item-disabled {
    background: #ffffff !important;
}

</style>
